import { createSelector } from 'reselect';

const tripDateCriteriaSelector = ({ tripDateCriteria }) => tripDateCriteria || {};

const getArrivalDate = createSelector(tripDateCriteriaSelector, ({ arrivalDate }) => arrivalDate);
const getDepartureDate = createSelector(
  tripDateCriteriaSelector,
  ({ departureDate }) => departureDate,
);
export { getArrivalDate, getDepartureDate };
